'use strict';

/**
 *
 * @name: nnHttpInterceptor
 *
 */

function nnHttpInterceptorFactory($rootScope, $q, $location) {

  'ngInject';

  return {

    'request': function(config) {
      // bysxz

      if (config.url.match($rootScope.apiUrlNew) || config.url.match($rootScope.apiUrlBak)) {

        angular.extend(config.headers, {
          'X-Nowness-Language': $rootScope.lang
        });
      }

      if (config.url.match($rootScope.apiUrlNew) &&
        $rootScope.token &&
        $rootScope.token.token &&
        !(config.method === 'POST' && (config.url === $rootScope.apiUrlNew + '/user' || config.url === $rootScope.apiUrlBak + '/token'))) {

        angular.extend(config.headers, {
          Authorization: $rootScope.token.token
        });
      }

      if (config.url.match(/lang.*json/)) {

        angular.extend(config.headers, {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        });
      }

      return config;
    },


    'requestError': function(rejection) {

      return $q.reject(rejection);
    },

    'response': function(response) {
      return response;
    },

    'responseError': function(rejection) {

      if (rejection && rejection.status === 403) {

        $location.path('/error403');
      }

      if (rejection && rejection.config && rejection.config.url.match($rootScope.apiUrlBak)) {

        if (rejection.data.message === 'Email is required') {

          rejection.data.message = 'EMAIL_REQUIRED_FACEBOOK';
        }

        if (rejection.data.message === 'Invalid social token') {

          rejection.data.message = 'INVALID_SOCIAL_TOKEN';
        }

        if (rejection.data.message === 'Invalid credentials') {

          rejection.data.message = 'INVALID_CREDENTIALS';
        }

        if (rejection.data.message === 'Unique constraint failed') {

          rejection.data.message = 'EMAIL_EXISTS';
        }
      }

      return $q.reject(rejection);
    }
  };
}

export default nnHttpInterceptorFactory;



// WEBPACK FOOTER //
// ./app/components/_api/nn-http-interceptor.factory.js